import React, { ReactNode, useState } from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import styled from 'styled-components';
import { getMediaListTaskFactory } from '~admin/interactor/media/perform-get-media-list';
import { MediaData } from '~admin/model/media-data';
import { TextField } from '~common/components/form/field-text.component';
import { MediaPickerSearchInner } from '~admin/view/components/ui/form/fields/media/media-overlay/media-picker-search-inner.component';
import { MediaType } from '~client/model/media-type';
import { Box } from '~common/components/box.component';
import { Size } from '~common/components/button/button.helper';
import { FormButton } from '~common/components/button/form-button.component';
import { FormFields } from '~common/components/form/form-fields.component';
import { useSuccessReaction } from '~common/hook/use-reaction';
import { useTask } from '~common/hook/use-task';
import { MagnifierIcon } from '~web/view/components/ui/icon/magnifier.icon';

interface Props {
  mediaType: MediaType;
  onCancel?: VoidFunction;
  onMediaSelected?: (media: MediaData) => void;
}

interface MediaSearchFormData {
  descriptionSearch: string;
}

export const MediaPickerSearch: React.FunctionComponent<Props> = ({
  mediaType,
  onCancel,
  onMediaSelected,
}) => {
  const getMediaListTask = useTask(getMediaListTaskFactory);
  const [mediaList, setMediaList] = useState<MediaData[]>(null);

  useSuccessReaction(getMediaListTask, (result: MediaData[]): void => {
    setMediaList(result);
    getMediaListTask.reset();
  });

  const onSubmit = (values: MediaSearchFormData): void => {
    getMediaListTask(values.descriptionSearch, mediaType);
  };

  const renderForm = (renderProps: FormRenderProps<MediaSearchFormData>): ReactNode => {
    return (
      <Container onSubmit={renderProps.handleSubmit}>
        <Search>
          <RestrictBox>
            <TextField
              name={'descriptionSearch'}
              autocomplete={'off'}
              startAdornment={<MagnifierIcon />}
            />
          </RestrictBox>
          <StyledButton size={Size.Small} task={getMediaListTask}>
            <MagnifierIcon width={32} height={32} />
          </StyledButton>
        </Search>
        <MediaPickerSearchInner
          mediaType={mediaType}
          mediaList={mediaList}
          onMediaSelected={(media: MediaData): void => {
            onMediaSelected(media);
            onCancel?.();
          }}
        />
      </Container>
    );
  };

  return <Form onSubmit={onSubmit} render={renderForm} />;
};

const Container = styled(FormFields)`
  align-items: center;
  margin-top: 12px;
`;

const Search = styled(Box)`
  width: 100%;
  align-items: center;
  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  padding: 16px 12px;
  margin: 0 4px;
`;

const RestrictBox = styled(Box)`
  flex: 1 1 auto;
  margin-right: 8px;

  .text-input-container {
    min-height: 50px;
    align-items: center;
  }
`;

const StyledButton = styled(FormButton)`
  && {
    padding: 0;
  }
`;



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/media/media-overlay/media-picker-search.component.tsx